import { types } from 'features/todolist/store/types'
import { types as taskTypes } from 'features/task/store/types'
import { types as appTypes } from 'features/app/store/types'

import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'

const initialState = {
  items: {
    onboarding: {
      list: []
    },
    today: {
      allDayEvents: [],
      list: []
    },
    tomorrow: {
      allDayEvents: [],
      list: []
    },
    upcoming: {
      list: []
    },
    backlog: {
      list: []
    },
    archiveWithUpdates: {
      list: []
    },
    archiveWithoutUpdates: {
      list: []
    }
  },
  isTodoListLoaded: false,
  highlightIds: [] /* array of ids */
}

const todolistReducer = (state = initialState, action) => {
  const { payload } = action
  let items = {}
  switch (action.type) {
    case taskTypes.UPDATE_TASK:
      if (!payload || !payload.group || payload.index === -1 || !payload.element) {
        return state
      }
      /* we update only if the item found in list is the same */
      if (get(state.items, `${payload.group}.list.${payload.index}.id`) !== get(payload, 'element.id')) {
        return state
      }
      items = Object.assign({}, state.items)
      items[payload.group].list = [].concat(items[payload.group].list)
      items[payload.group].list[payload.index] = payload.element

      return {
        ...state,
        items
      }
    case taskTypes.REMOVE_TASK:
      if (!payload || !payload.group || payload.index === -1 || !payload.taskId) {
        return state
      }
      /* we remove only if the item found in list is the same */
      if (get(state.items, `${payload.group}.list.${payload.index}.id`) !== get(payload, 'taskId')) {
        return state
      }
      items = cloneDeep(state.items)
      items[payload.group].list.splice(payload.index, 1)

      return {
        ...state,
        items
      }

    case appTypes.HIGHLIGHT_ELEMENTS:
      return {
        ...state,
        highlightIds: action.payload || []
      }

    case types.ADD_ARCHIVE_ITEMS:
      if (!payload) {
        return state
      }
      const withoutUpdates = cloneDeep(state.items.archiveWithoutUpdates)
      withoutUpdates.list = withoutUpdates.list.concat(payload)
      return {
        ...state,
        items: {
          ...state.items,
          archiveWithoutUpdates: withoutUpdates
        }
      }

    case types.SET_TODO_ITEMS:
      return {
        ...state,
        items: {
          ...state.items,
          ...action.payload
        }
      }

    case types.SET_TODO_ITEMS_FOR_GROUP:
      const group = action.payload.group
      const newState = {
        ...state,
        items: {
          ...state.items
        }
      }
      newState.items[group].list = [].concat(action.payload.list)

      return newState

    case types.SET_TODOLIST_LOADED:
      return {
        ...state,
        isTodolistLoaded: action.payload
      }

    default:
      break
  }
  return state
}

export default todolistReducer



// WEBPACK FOOTER //
// ./src/features/todolist/store/reducer.js